// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar for the user dashboard.
   The photo sits behind the lower half and fades up into the panel, so the nav
   stays readable over it. Two files, one per theme, picked in the component. */

.ql-side {
  --ql-side-w: 255px;
  --ql-side-w-collapsed: 76px;
  position: relative;
  display: flex;
  flex-direction: column;
  width: var(--ql-side-w);
  flex: 0 0 var(--ql-side-w);
  height: 100vh;
  position: sticky;
  top: 0;
  overflow: hidden;
  background: #ffffff;
  border-right: 1px solid #e8edf5;
  transition: width 220ms cubic-bezier(0.4, 0, 0.2, 1),
              flex-basis 220ms cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 30;
}

.ql-side.is-collapsed {
  width: var(--ql-side-w-collapsed);
  flex-basis: var(--ql-side-w-collapsed);
}

.dark .ql-side {
  background: #0d1424;
  border-right-color: #1b2740;
}

/* ── the photo ───────────────────────────────────────────────────────────── */
.ql-side__art {
  position: absolute;
  inset: auto 0 0 0;
  height: 62%;
  background-position: center bottom;
  /* The photo is a 9:16 frame and the panel is far narrower, so \`cover\` ate the
     tail and the nose. Matching the width instead keeps the whole aircraft in
     view; a short viewport crops the sky off the top, which costs nothing. */
  background-size: 100% auto;
  background-repeat: no-repeat;
  pointer-events: none;
  /* fade the top edge into the panel instead of cutting it off */
  /* At this width the frame fills the bottom ~77% of the box, so the fade only
     starts there — otherwise the photo's top edge lands mid-ramp and draws a
     line across the panel. */
  mask-image: linear-gradient(to bottom, transparent 0%, transparent 23%, rgba(0, 0, 0, 0.16) 32%, rgba(0, 0, 0, 0.62) 48%, #000 66%);
}

/* Collapsed, the panel is too narrow for the full frame to read — fill it with
   a slice instead. */
.ql-side.is-collapsed .ql-side__art {
  background-size: cover;
}

.ql-side__body {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

/* ── logo ────────────────────────────────────────────────────────────────── */
.ql-side__brand {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 18px 20px 14px;
  min-height: 84px;
}

.ql-side__brand img {
  height: 46px;
  width: auto;
  object-fit: contain;
  flex-shrink: 0;
}

.ql-side.is-collapsed .ql-side__brand {
  padding-left: 0;
  padding-right: 0;
  justify-content: center;
}

.ql-side.is-collapsed .ql-side__brand img { height: 36px; }
.ql-side.is-collapsed .ql-side__toggle { top: auto; bottom: 18px; right: 50%; transform: translateX(50%); }

/* ── nav ─────────────────────────────────────────────────────────────────── */
.ql-side__nav {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 4px 14px 16px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
}
.ql-side__nav::-webkit-scrollbar { display: none; }

.ql-side.is-collapsed .ql-side__nav { padding-left: 12px; padding-right: 12px; }

.ql-side__item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 11px 14px;
  border: 0;
  border-radius: 12px;
  background: transparent;
  color: #46526b;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 140ms ease, color 140ms ease;
}

.ql-side__item:hover { background: #f1f5fb; color: #1e293b; }
.dark .ql-side__item { color: #9fb0cc; }
.dark .ql-side__item:hover { background: rgba(255, 255, 255, 0.06); color: #e7eefc; }

.ql-side__item.is-active {
  background: linear-gradient(135deg, #2f6fe4 0%, #2563eb 100%);
  color: #ffffff;
  box-shadow: 0 6px 16px -6px rgba(37, 99, 235, 0.65);
}
.ql-side__item.is-active:hover { background: linear-gradient(135deg, #2f6fe4 0%, #2563eb 100%); color: #fff; }

.ql-side__icon { flex-shrink: 0; display: grid; place-items: center; }
.ql-side__label { flex: 1 1; overflow: hidden; text-overflow: ellipsis; }

.ql-side__chev {
  flex-shrink: 0;
  transition: transform 160ms ease;
  opacity: 0.75;
}
.ql-side__chev.is-open { transform: rotate(90deg); }

.ql-side.is-collapsed .ql-side__label,
.ql-side.is-collapsed .ql-side__chev { display: none; }

.ql-side.is-collapsed .ql-side__item {
  justify-content: center;
  padding-left: 0;
  padding-right: 0;
}

/* ── sub items ───────────────────────────────────────────────────────────── */
.ql-side__sub {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-left: 14px;
  margin-top: 2px;
}

.ql-side__subitem {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: #5b6880;
  font-size: 13.5px;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 140ms ease, color 140ms ease;
}
.ql-side__subitem:hover { background: #f1f5fb; color: #1e293b; }
.dark .ql-side__subitem { color: #93a4c1; }
.dark .ql-side__subitem:hover { background: rgba(255, 255, 255, 0.06); color: #e7eefc; }

.ql-side__subitem.is-active {
  background: #e7efff;
  color: #1d4ed8;
}
.dark .ql-side__subitem.is-active {
  background: rgba(59, 130, 246, 0.18);
  color: #93c5fd;
}

/* ── "New Booking" sits apart, with its own tile ─────────────────────────── */
.ql-side__cta .ql-side__icon {
  width: 28px;
  height: 28px;
  border-radius: 9px;
  background: #2563eb;
  color: #fff;
}
.ql-side__cta.is-active .ql-side__icon { background: rgba(255, 255, 255, 0.22); }

/* ── collapse toggle ─────────────────────────────────────────────────────── */
.ql-side__toggle {
  position: absolute;
  top: 30px;
  right: 10px;
  z-index: 3;
  display: grid;
  place-items: center;
  width: 28px;
  height: 28px;
  border-radius: 9px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #475569;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.12);
  transition: background-color 140ms ease, color 140ms ease, transform 140ms ease;
}
.ql-side__toggle:hover { background: #2563eb; border-color: #2563eb; color: #fff; }
.dark .ql-side__toggle {
  background: #16203a;
  border-color: #27344f;
  color: #9fb0cc;
}
.dark .ql-side__toggle:hover { background: #2563eb; border-color: #2563eb; color: #fff; }

/* ── mobile: slide over instead of taking a column ───────────────────────── */
.ql-side__scrim {
  position: fixed;
  inset: 0;
  background: rgba(8, 13, 25, 0.55);
  backdrop-filter: blur(2px);
  z-index: 29;
  border: 0;
  padding: 0;
}

@media (max-width: 1023px) {
  .ql-side {
    position: fixed;
    inset: 0 auto 0 0;
    flex-basis: auto;
    transform: translateX(-100%);
    transition: transform 220ms cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 0 40px rgba(8, 13, 25, 0.25);
  }
  .ql-side.is-open { transform: translateX(0); }
  .ql-side.is-collapsed { width: var(--ql-side-w); }
  .ql-side.is-collapsed .ql-side__label,
  .ql-side.is-collapsed .ql-side__chev { display: block; }
  .ql-side.is-collapsed .ql-side__item { justify-content: flex-start; padding-left: 14px; padding-right: 14px; }
  .ql-side__toggle { display: none; }
}

/* ── admin variants ──────────────────────────────────────────────────────────
   The admin consoles reuse the panel, the photo and the collapse behaviour, and
   add a role badge, grouped sections, counts and a cluster chip. */
.ql-side__role {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-top: 6px;
  padding: 3px 10px;
  border-radius: 999px;
  background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);
  color: #fff;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  white-space: nowrap;
}
.ql-side.is-collapsed .ql-side__role { display: none; }

.ql-side__section {
  padding: 14px 18px 6px;
  font-size: 10.5px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #94a3b8;
  white-space: nowrap;
}
.dark .ql-side__section { color: #64748b; }
.ql-side.is-collapsed .ql-side__section {
  padding: 12px 0 6px;
  text-align: center;
  font-size: 0;
}
.ql-side.is-collapsed .ql-side__section::after {
  content: '';
  display: block;
  width: 22px;
  height: 1px;
  margin: 0 auto;
  background: #e2e8f0;
}
.dark .ql-side.is-collapsed .ql-side__section::after { background: #1f2a40; }

.ql-side__count {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  background: #ef4444;
  color: #fff;
  font-size: 10.5px;
  font-weight: 800;
  line-height: 1;
}
.ql-side__item.is-active .ql-side__count { background: rgba(255, 255, 255, 0.28); }
.ql-side.is-collapsed .ql-side__count {
  position: absolute;
  top: 4px;
  right: 10px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  font-size: 9px;
}
.ql-side.is-collapsed .ql-side__item { position: relative; }

`, "",{"version":3,"sources":["webpack://./src/components/Layout/UserSidebar.css"],"names":[],"mappings":"AAAA;;+EAE+E;;AAE/E;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;EAChB,MAAM;EACN,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B;2DACyD;EACzD,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,kCAAkC;EAClC;;6EAE2E;EAC3E,0BAA0B;EAC1B,4BAA4B;EAC5B,oBAAoB;EACpB,+DAA+D;EAC/D;;6BAE2B;EAE3B,mIAAmI;AACrI;;AAEA;qBACqB;AACrB;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,4CAA4C,YAAY,EAAE;AAC1D,yCAAyC,SAAS,EAAE,YAAY,EAAE,UAAU,EAAE,0BAA0B,EAAE;;AAE1G,+EAA+E;AAC/E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;AACA,mCAAmC,aAAa,EAAE;;AAElD,sCAAsC,kBAAkB,EAAE,mBAAmB,EAAE;;AAE/E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,uBAAuB,cAAc,EAAE;AACvC,6BAA6B,qCAAqC,EAAE,cAAc,EAAE;;AAEpF;EACE,6DAA6D;EAC7D,cAAc;EACd,mDAAmD;AACrD;AACA,iCAAiC,6DAA6D,EAAE,WAAW,EAAE;;AAE7G,iBAAiB,cAAc,EAAE,aAAa,EAAE,mBAAmB,EAAE;AACrE,kBAAkB,SAAO,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;;AAEtE;EACE,cAAc;EACd,gCAAgC;EAChC,aAAa;AACf;AACA,yBAAyB,wBAAwB,EAAE;;AAEnD;uCACuC,aAAa,EAAE;;AAEtD;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yDAAyD;AAC3D;AACA,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D,0BAA0B,cAAc,EAAE;AAC1C,gCAAgC,qCAAqC,EAAE,cAAc,EAAE;;AAEvF;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,+EAA+E;AAC/E;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;AACA,yCAAyC,qCAAqC,EAAE;;AAEhF,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,4CAA4C;EAC5C,+EAA+E;AACjF;AACA,yBAAyB,mBAAmB,EAAE,qBAAqB,EAAE,WAAW,EAAE;AAClF;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA,+BAA+B,mBAAmB,EAAE,qBAAqB,EAAE,WAAW,EAAE;;AAExF,+EAA+E;AAC/E;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,0BAA0B;EAC1B,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,4BAA4B;IAC5B,wDAAwD;IACxD,0CAA0C;EAC5C;EACA,mBAAmB,wBAAwB,EAAE;EAC7C,wBAAwB,uBAAuB,EAAE;EACjD;yCACuC,cAAc,EAAE;EACvD,uCAAuC,2BAA2B,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;EAC7G,mBAAmB,aAAa,EAAE;AACpC;;AAEA;;mEAEmE;AACnE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,6DAA6D;EAC7D,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;AACA,uCAAuC,aAAa,EAAE;;AAEtD;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;AACA,0BAA0B,cAAc,EAAE;AAC1C;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;AACA,uDAAuD,mBAAmB,EAAE;;AAE5E;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA,2CAA2C,qCAAqC,EAAE;AAClF;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;AACA,uCAAuC,kBAAkB,EAAE","sourcesContent":["/* Sidebar for the user dashboard.\n   The photo sits behind the lower half and fades up into the panel, so the nav\n   stays readable over it. Two files, one per theme, picked in the component. */\n\n.ql-side {\n  --ql-side-w: 255px;\n  --ql-side-w-collapsed: 76px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: var(--ql-side-w);\n  flex: 0 0 var(--ql-side-w);\n  height: 100vh;\n  position: sticky;\n  top: 0;\n  overflow: hidden;\n  background: #ffffff;\n  border-right: 1px solid #e8edf5;\n  transition: width 220ms cubic-bezier(0.4, 0, 0.2, 1),\n              flex-basis 220ms cubic-bezier(0.4, 0, 0.2, 1);\n  z-index: 30;\n}\n\n.ql-side.is-collapsed {\n  width: var(--ql-side-w-collapsed);\n  flex-basis: var(--ql-side-w-collapsed);\n}\n\n.dark .ql-side {\n  background: #0d1424;\n  border-right-color: #1b2740;\n}\n\n/* ── the photo ───────────────────────────────────────────────────────────── */\n.ql-side__art {\n  position: absolute;\n  inset: auto 0 0 0;\n  height: 62%;\n  background-position: center bottom;\n  /* The photo is a 9:16 frame and the panel is far narrower, so `cover` ate the\n     tail and the nose. Matching the width instead keeps the whole aircraft in\n     view; a short viewport crops the sky off the top, which costs nothing. */\n  background-size: 100% auto;\n  background-repeat: no-repeat;\n  pointer-events: none;\n  /* fade the top edge into the panel instead of cutting it off */\n  /* At this width the frame fills the bottom ~77% of the box, so the fade only\n     starts there — otherwise the photo's top edge lands mid-ramp and draws a\n     line across the panel. */\n  -webkit-mask-image: linear-gradient(to bottom, transparent 0%, transparent 23%, rgba(0, 0, 0, 0.16) 32%, rgba(0, 0, 0, 0.62) 48%, #000 66%);\n  mask-image: linear-gradient(to bottom, transparent 0%, transparent 23%, rgba(0, 0, 0, 0.16) 32%, rgba(0, 0, 0, 0.62) 48%, #000 66%);\n}\n\n/* Collapsed, the panel is too narrow for the full frame to read — fill it with\n   a slice instead. */\n.ql-side.is-collapsed .ql-side__art {\n  background-size: cover;\n}\n\n.ql-side__body {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n}\n\n/* ── logo ────────────────────────────────────────────────────────────────── */\n.ql-side__brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 18px 20px 14px;\n  min-height: 84px;\n}\n\n.ql-side__brand img {\n  height: 46px;\n  width: auto;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n.ql-side.is-collapsed .ql-side__brand {\n  padding-left: 0;\n  padding-right: 0;\n  justify-content: center;\n}\n\n.ql-side.is-collapsed .ql-side__brand img { height: 36px; }\n.ql-side.is-collapsed .ql-side__toggle { top: auto; bottom: 18px; right: 50%; transform: translateX(50%); }\n\n/* ── nav ─────────────────────────────────────────────────────────────────── */\n.ql-side__nav {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 4px 14px 16px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-width: none;\n}\n.ql-side__nav::-webkit-scrollbar { display: none; }\n\n.ql-side.is-collapsed .ql-side__nav { padding-left: 12px; padding-right: 12px; }\n\n.ql-side__item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 11px 14px;\n  border: 0;\n  border-radius: 12px;\n  background: transparent;\n  color: #46526b;\n  font-size: 14px;\n  font-weight: 600;\n  text-align: left;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background-color 140ms ease, color 140ms ease;\n}\n\n.ql-side__item:hover { background: #f1f5fb; color: #1e293b; }\n.dark .ql-side__item { color: #9fb0cc; }\n.dark .ql-side__item:hover { background: rgba(255, 255, 255, 0.06); color: #e7eefc; }\n\n.ql-side__item.is-active {\n  background: linear-gradient(135deg, #2f6fe4 0%, #2563eb 100%);\n  color: #ffffff;\n  box-shadow: 0 6px 16px -6px rgba(37, 99, 235, 0.65);\n}\n.ql-side__item.is-active:hover { background: linear-gradient(135deg, #2f6fe4 0%, #2563eb 100%); color: #fff; }\n\n.ql-side__icon { flex-shrink: 0; display: grid; place-items: center; }\n.ql-side__label { flex: 1; overflow: hidden; text-overflow: ellipsis; }\n\n.ql-side__chev {\n  flex-shrink: 0;\n  transition: transform 160ms ease;\n  opacity: 0.75;\n}\n.ql-side__chev.is-open { transform: rotate(90deg); }\n\n.ql-side.is-collapsed .ql-side__label,\n.ql-side.is-collapsed .ql-side__chev { display: none; }\n\n.ql-side.is-collapsed .ql-side__item {\n  justify-content: center;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n/* ── sub items ───────────────────────────────────────────────────────────── */\n.ql-side__sub {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding-left: 14px;\n  margin-top: 2px;\n}\n\n.ql-side__subitem {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 12px;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  color: #5b6880;\n  font-size: 13.5px;\n  font-weight: 600;\n  text-align: left;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background-color 140ms ease, color 140ms ease;\n}\n.ql-side__subitem:hover { background: #f1f5fb; color: #1e293b; }\n.dark .ql-side__subitem { color: #93a4c1; }\n.dark .ql-side__subitem:hover { background: rgba(255, 255, 255, 0.06); color: #e7eefc; }\n\n.ql-side__subitem.is-active {\n  background: #e7efff;\n  color: #1d4ed8;\n}\n.dark .ql-side__subitem.is-active {\n  background: rgba(59, 130, 246, 0.18);\n  color: #93c5fd;\n}\n\n/* ── \"New Booking\" sits apart, with its own tile ─────────────────────────── */\n.ql-side__cta .ql-side__icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 9px;\n  background: #2563eb;\n  color: #fff;\n}\n.ql-side__cta.is-active .ql-side__icon { background: rgba(255, 255, 255, 0.22); }\n\n/* ── collapse toggle ─────────────────────────────────────────────────────── */\n.ql-side__toggle {\n  position: absolute;\n  top: 30px;\n  right: 10px;\n  z-index: 3;\n  display: grid;\n  place-items: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 9px;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  color: #475569;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.12);\n  transition: background-color 140ms ease, color 140ms ease, transform 140ms ease;\n}\n.ql-side__toggle:hover { background: #2563eb; border-color: #2563eb; color: #fff; }\n.dark .ql-side__toggle {\n  background: #16203a;\n  border-color: #27344f;\n  color: #9fb0cc;\n}\n.dark .ql-side__toggle:hover { background: #2563eb; border-color: #2563eb; color: #fff; }\n\n/* ── mobile: slide over instead of taking a column ───────────────────────── */\n.ql-side__scrim {\n  position: fixed;\n  inset: 0;\n  background: rgba(8, 13, 25, 0.55);\n  backdrop-filter: blur(2px);\n  z-index: 29;\n  border: 0;\n  padding: 0;\n}\n\n@media (max-width: 1023px) {\n  .ql-side {\n    position: fixed;\n    inset: 0 auto 0 0;\n    flex-basis: auto;\n    transform: translateX(-100%);\n    transition: transform 220ms cubic-bezier(0.4, 0, 0.2, 1);\n    box-shadow: 0 0 40px rgba(8, 13, 25, 0.25);\n  }\n  .ql-side.is-open { transform: translateX(0); }\n  .ql-side.is-collapsed { width: var(--ql-side-w); }\n  .ql-side.is-collapsed .ql-side__label,\n  .ql-side.is-collapsed .ql-side__chev { display: block; }\n  .ql-side.is-collapsed .ql-side__item { justify-content: flex-start; padding-left: 14px; padding-right: 14px; }\n  .ql-side__toggle { display: none; }\n}\n\n/* ── admin variants ──────────────────────────────────────────────────────────\n   The admin consoles reuse the panel, the photo and the collapse behaviour, and\n   add a role badge, grouped sections, counts and a cluster chip. */\n.ql-side__role {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  margin-top: 6px;\n  padding: 3px 10px;\n  border-radius: 999px;\n  background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);\n  color: #fff;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n.ql-side.is-collapsed .ql-side__role { display: none; }\n\n.ql-side__section {\n  padding: 14px 18px 6px;\n  font-size: 10.5px;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #94a3b8;\n  white-space: nowrap;\n}\n.dark .ql-side__section { color: #64748b; }\n.ql-side.is-collapsed .ql-side__section {\n  padding: 12px 0 6px;\n  text-align: center;\n  font-size: 0;\n}\n.ql-side.is-collapsed .ql-side__section::after {\n  content: '';\n  display: block;\n  width: 22px;\n  height: 1px;\n  margin: 0 auto;\n  background: #e2e8f0;\n}\n.dark .ql-side.is-collapsed .ql-side__section::after { background: #1f2a40; }\n\n.ql-side__count {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 20px;\n  height: 20px;\n  padding: 0 6px;\n  border-radius: 999px;\n  background: #ef4444;\n  color: #fff;\n  font-size: 10.5px;\n  font-weight: 800;\n  line-height: 1;\n}\n.ql-side__item.is-active .ql-side__count { background: rgba(255, 255, 255, 0.28); }\n.ql-side.is-collapsed .ql-side__count {\n  position: absolute;\n  top: 4px;\n  right: 10px;\n  min-width: 16px;\n  height: 16px;\n  padding: 0 4px;\n  font-size: 9px;\n}\n.ql-side.is-collapsed .ql-side__item { position: relative; }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
